var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-3"},[_c('ValidationIcon',{attrs:{"value":_vm.value || _vm.exludeValidation}}),_vm._v(" "+_vm._s(_vm.label)+" "),_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.value))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }